import type { RunKpis } from "@/types/sim-sandbox.types";

// Composição simulado × real de uma OP executada (backtest). Projeção (motor) vs
// registro real (indicadores da OP). Lacuna em qualquer lado ⇒ delta null (exibido como "—"),
// nunca inventa valor.

export interface RealIndicators {
  oee: number | null;
  availability: number | null;
  performance: number | null;
  quality: number | null;
  producedQty: number | null;
}

export interface SimVsRealRow {
  label: string;
  sim: number | null;
  real: number | null;
  delta: number | null;
  unit: "pct" | "count";
}

const round1 = (n: number): number => Number(n.toFixed(1));

export function composeSimVsReal(sim: RunKpis, real: RealIndicators): SimVsRealRow[] {
  const pct = (label: string, s: number | null, r: number | null): SimVsRealRow => ({
    label,
    sim: s,
    real: r,
    delta: s == null || r == null ? null : round1(s - r),
    unit: "pct",
  });
  return [
    pct("OEE", sim.oee, real.oee),
    pct("Disponibilidade", sim.availability, real.availability),
    pct("Desempenho", sim.performance, real.performance),
    pct("Qualidade", sim.quality, real.quality),
    {
      label: "Produção",
      sim: sim.estimatedProduction,
      real: real.producedQty,
      delta:
        sim.estimatedProduction == null || real.producedQty == null
          ? null
          : sim.estimatedProduction - real.producedQty,
      unit: "count",
    },
  ];
}
